import { useRef, useState } from "react";
import Modal from "../Modal";
import { RequiredInput } from "../RequiredInput";
import formToObj from "../../utils/formToObj";
import Api from "../../utils/api";
import OBJtoXML from "../../utils/objToXML";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

interface ICuota {
  show: boolean;
  onImprimirFactura: boolean;
  BOTON_ACTUALIZAR: boolean;
  CLAVE_EMISION: string;
  CONCEPTO: string;
  D_IMPORTE: string;
  D_IMPORTE2: string;
  D_PAGO: boolean;
  D_PRI_VEN: string;
  D_SEG_VEN: string;
  D_SEN: string;
  D_VENCIDO: boolean;
  IMP_PAGAR: string;
  IMP_TRANSFERIR: number;
  MONEDA: string;
  NU_FACTURA: string;
  NU_TALON: string;
}

interface IProps {
  show: boolean;
  onClose: Function;
  cuota: ICuota | null;
  id: string;
}

export default function ModalInformarPago({
  show,
  onClose,
  cuota,
  id,
}: IProps) {
  const formRef = useRef<HTMLFormElement | null>(null);
  const [load, setLoad] = useState(false);
  const [message, setMessage] = useState("");
  const [hasError, setHasError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleInformar = () => {
    if (!formRef.current) return;
    const form = formToObj(formRef.current);
    const date = (form.FECHA_TRANSFERENCIA as string).split("-");
    form.FECHA_TRANSFERENCIA = `${date[2]}/${date[1]}/${date[0]}`;
    form.CO_PASAJERO = id;
    form.NU_TALON = cuota?.NU_TALON ?? "";
    form.IMPORTE = cuota?.IMP_TRANSFERIR.toString() ?? "";

    setLoad(true);

    Api("consumir")
      .post({
        servicio: "cargarTB",
        param: {
          pc_request: OBJtoXML({ PAGO_TRANSFERNECIA: form }),
        },
      })
      .then((res) => {
        setMessage(res.mensaje.descripcion);
        setHasError(res.mensaje.tipo === "E");
        if (res.mensaje.tipo === "E") {
          return;
        }
        setShowModal(true);
      })
      .catch((error: any) => {
        setHasError(true);
        setMessage(error.message);
      })
      .finally(() => {
        setLoad(false);
      });
  };

  const handleCloseModalSuccess = () => {
    window.location.href = "";
    setShowModal(false);
    setHasError(false);
    setMessage("");
    onClose();
  };

  if (!cuota) return <></>;
  return (
    <Modal
      onLoadAceptar={load}
      size={"modal-lg"}
      title="Registro de Transferencia Bancaria"
      onClose={() => onClose()}
      show={show}
      onAceptar={handleInformar}
      btnAceptar="Aceptar"
    >
      <form ref={formRef}>
        <div className="row border rounded p-3 m-3">
          <div className="col-12">
            <h5 className="color-platform" style={{ fontWeight: 900 }}>
              Datos de la Cuota
            </h5>
          </div>
          <div className="col-md-6 col-12 form-group mb-3">
            <label className="form-label">
              Nro. Cuota
              <RequiredInput />
            </label>
            <input
              className="form-control"
              type="number"
              name="NU_TALON"
              defaultValue={cuota.NU_TALON}
              disabled
            />
          </div>
          <div className="col-md-6 col-12 form-group mb-3">
            <label className="form-label">
              Importe
              <RequiredInput />
            </label>
            <input
              className="form-control"
              type="number"
              name="IMPORTE"
              defaultValue={cuota.IMP_TRANSFERIR}
              disabled
            />
          </div>
        </div>
        <div className="row border rounded p-3 m-3">
          <h5 className="color-platform col-12" style={{ fontWeight: 900 }}>
            Datos de la Transferencia
          </h5>
          <div className="form-group mb-3 col-md-6 col-12">
            <label className="form-label">
              Banco Origen
              <RequiredInput />
            </label>
            <input className="form-control" type="text" name="BANCO" />
          </div>
          <div className="form-group mb-3 col-md-6 col-12">
            <label className="form-label">
              Cuenta Origen
              <RequiredInput />
            </label>
            <input className="form-control" type="text" name="CUENTA" />
          </div>
          <div className="form-group mb-3 col-md-6 col-12">
            <label className="form-label">
              CUIL/CUIT del Titular
              <RequiredInput />
            </label>
            <input
              className="form-control"
              type="number"
              name="CUIL_CUIT"
              placeholder="Ingrese 11 digitos sin guiones"
            />
          </div>
          <div className="form-group mb-3 col-md-6 col-12">
            <label className="form-label">
              Titular
              <RequiredInput />
            </label>
            <input className="form-control" type="text" name="TITULAR" />
          </div>
          <div className="form-group mb-3 col-md-6 col-12">
            <label className="form-label">
              Fecha de Transferencia
              <RequiredInput />
            </label>
            <input
              className="form-control"
              type="date"
              name="FECHA_TRANSFERENCIA"
            />
          </div>
        </div>
        {hasError && (
          <p
            className={`ms-3 "text-success`}
            dangerouslySetInnerHTML={{ __html: message }}
          ></p>
        )}
      </form>
      <Modal title="" onClose={handleCloseModalSuccess} show={showModal}>
        <div className="text-center">
          <FontAwesomeIcon color="#20c997" icon={faCheckCircle} fontSize={80} />
          <h5
            className="d-block mt-3"
            dangerouslySetInnerHTML={{ __html: message }}
          ></h5>
        </div>
      </Modal>
    </Modal>
  );
}
